import { Controller } from "@hotwired/stimulus"

// Mobile slide-out menu — toggles a drawer overlay on < lg breakpoints.
// Handles: backdrop click dismiss, ESC key dismiss, body scroll lock.
export default class extends Controller {
  static targets = ["drawer", "backdrop"]

  connect() {
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    if (this.drawerTarget.classList.contains("translate-x-0")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Show backdrop
    this.backdropTarget.classList.remove("hidden")
    // Slide drawer in (from -translate-x-full to translate-x-0)
    requestAnimationFrame(() => {
      this.backdropTarget.classList.add("opacity-100")
      this.backdropTarget.classList.remove("opacity-0")
      this.drawerTarget.classList.remove("-translate-x-full")
      this.drawerTarget.classList.add("translate-x-0")
    })
    // Lock body scroll
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    // Slide drawer out
    this.drawerTarget.classList.remove("translate-x-0")
    this.drawerTarget.classList.add("-translate-x-full")
    // Fade backdrop
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    // After transition, hide backdrop entirely
    setTimeout(() => {
      this.backdropTarget.classList.add("hidden")
    }, 300)
    // Unlock body scroll
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._onKeydown)
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
